import { msg } from '../messages'
import * as Util from '../util'

export function required(value: any) {
  if (Util.isEmpty(value) || !/\S/.test(value)) {
    return msg('required', value)
  }
}

export function requiredTrim(value: any) {
  const trimValue = typeof value === 'string' ? value.trim() : value

  if (Util.isEmpty(trimValue) || !/\S/.test(trimValue)) {
    return msg('required', trimValue)
  }
}
